import React, { useEffect, useState } from "react";
import {
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { ServiceApi } from "../services/index.service";
import NonMandatoryPromotions from "./NonMandatoryPromotions";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddPromotionDialog from "./AddPromotionDialog";
import dayjs from "dayjs";


const DriveThruPreSellBoardConfiguration = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const [nonMandatoryList, setNonMandatoryList] = useState([]);
  const initival = {
    intBannerID: 0,
    vchBannerName: "",
    vchBannerURL: "",
    bitActive: 0,
    bitMandatory: 0,
    dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitBannerType: 1,
    dteDateCreated: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitVertical: 1,
  };
  const [selectedPromotion, setSelectedPromotion] = useState(initival);
  const [action, setAction] = useState("Add");
  const [showDialog, setShowDialog] = useState(false);
  const data = useSelector((state) => state);

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedPromotion(initival);
    setAction("Add");
  };

  const handleEdit = (dataItem) => {
    setAction("Update");
    setSelectedPromotion(dataItem);
    setShowDialog(true);
  };
  const handleDelete = async (dataItem) => {
    let req = {
      intBannerID: dataItem?.intBannerID,
      action:'delete',
      vchBannerName:dataItem?.vchBannerName,
      vchBannerURL:dataItem?.vchBannerURL
    };
    setBtnLoading(true);
    const res = await serviceapi.savePresellBoardAdmin(req);
    setBtnLoading(false);
    if (res?.success) {
      const message = "Promotion Deleted Successfully";
      setSelectedPromotion(initival);
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      fetchPresellOrderList();
    } else {
      const message = "Error in Deleting Promotion";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  const serviceapi = new ServiceApi();

  useEffect(() => {
    fetchPresellOrderList();
  }, [props?.success]);

  const fetchPresellOrderList = async () => {
    const req = {
      role: data?.profile?.role,
      user_name: data?.profile?.user_name,
      bitBannerType: 1,
      intStoreID:props?.intStoreID
    };
    setLoading(true);
    const res = await serviceapi.getPresellStoreLevelOrderList(req);
    setLoading(false);
    const result = res?.data;
    setNonMandatoryList(result);
  };

  const handlePromotion = (value, name) => {
    if (name === "Mandatory" && !value) {
      setSelectedPromotion({
        ...selectedPromotion,
        [name]: value,
        dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    } else if (name === "bitBannerType") {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    } else {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    }
  };

  const onSubmit = async () => {
    console.log(selectedPromotion);
    let req = {
      intBannerID: selectedPromotion?.intBannerID,
      bitActive: selectedPromotion?.bitActive ? 1 : 0,
      intStoreID:props?.intStoreID
    };
    setBtnLoading(true);
    // if (action === "Add") {
    //   req = { ...req, intBannerID: 0 };
    // }
    const res = await serviceapi.UpdateStoreLevelPresellStatus(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.success) {
      let message = "Promotion Added Successfully";
      if (action === "Update") {
        message = "Promotion Updated Successfully";
      }
      setShowDialog(false);
      setSelectedPromotion(initival);
      fetchPresellOrderList();
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      let message = "Error in Adding Promotion";
      if (action === "Update") {
        message = "Error in Updating Promotion";
      }
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };

  const handleUpdateOrder = async (list) => {
    const req = {body:list,intStoreID:props?.intStoreID};
    setBtnLoading(true)
    const res = await serviceapi.savePresellBoardOrder(req);
    setBtnLoading(false)
    console.log(res);
    if (res?.success) {
      const message = "Order Updated Successfully";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      fetchPresellOrderList();
    } else {
      const message = "Error in  updating order";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      fetchPresellOrderList();
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading || btnloading}
        onClick={handleCloseDialog}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <main>
        <NonMandatoryPromotions
          loading={loading}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          promotionsList={nonMandatoryList}
          handleUpdateOrder={handleUpdateOrder}
        />
      </main>
      {showDialog ? (
        <AddPromotionDialog
          showDialog={showDialog}
          handleCloseDialog={handleCloseDialog}
          action={action}
          IsAdmin={false}
          selectedPromotion={selectedPromotion}
          handlePromotion={handlePromotion}
          btnloading={btnloading}
          onSubmit={onSubmit}
          setSelectedPromotion={setSelectedPromotion}
        />
      ) : null}
    </>
  );
};

export default DriveThruPreSellBoardConfiguration;
